<template>
    <div>
        <Header title="客户资料" :is_back="true" :type="location_type">
            <template v-slot:content>
                <div style="float:right">
                    <img style="width:20px;height:20px" src="../../assets/reback.png" />
                </div>
            </template>
        </Header>
        <div style="display: flex">
            <div style="flex:1" class="my-mod-right my_cla">
                <div class="my-white-mod">
                    <div class="title-class">
                        <div class="title-font">详细资料</div>
                        <div @click="show_infos = true"><span class="edit"></span></div>
                    </div>
                    <div class="head-content">
                        <img class="head-content-img"  v-if="details.custom_dict.avatar" :src="details.custom_dict.avatar" />
                        <img class="head-content-img" v-else src="../../assets/21.png" />
                        <div class="head-content-name">
                            <div class="head-content-name-class ">
                                {{details.custom_dict.name}}<img v-if="details.custom_dict.gender == 1" src="../../assets/11.png" class="head-content-name-img"/><img v-else src="../../assets/12.png" class="head-content-name-img"/>
                                <img v-if="submitInfo.is_big == 1" src="@/assets/is_big.png" class="is-big"/>
                            </div>
                            <div>备注：{{details.custom_dict.remark}}</div>
                        </div>
                    </div>
                    <div style="margin-top:10px" >
                        <Row>
                            <Col span="12">手机号：{{details.custom_dict.phone}}</Col>
                            <Col span="12">微信号：{{details.custom_dict.wechatNumber}}</Col>
                        </Row>
                        <Row>
                            <Col span="12">旺旺号：{{details.custom_dict.wangwangNumber}}</Col>
                            <Col span="12">邮箱：{{details.custom_dict.email}}</Col>
                        </Row>
                        <Row>
                            <Col span="10">出生年月：{{details.custom_dict.birthday}}</Col>
                        </Row>
                        <Row>
                            <Col span="24">营业执照名：{{details.custom_dict.companyName}}</Col>
                        </Row>
                        <Row>
                            <Col span="24">所属城市：{{details.custom_dict.city_name}}</Col>
                        </Row>
                        <Row>
                            <Col span="24">详细地址：{{details.custom_dict.detailedAddress}}</Col>
                        </Row>
                    </div>
                </div>
                <div class="my-white-mod">
                    <div class="title-class">
                        <div class="title-font" style="display:flex;justify-content: center;align-items: center;cursor: pointer;" @click="showQrcodeModal">
                            用户详情
                            <img style="width:20px;height:20px;margin-left:5px" class="qrcode" src="../../assets/code.png">
                        </div>
                        <div @click="show_infos_portrait = true"><span class="edit"></span></div>
                    </div>
                    <div style="margin-top:20px">
                        <div>
                            标签
                        </div>
                        <div class="tag-content" v-if="details.tag_dict && details.tag_dict.length > 0">
                            <span v-for="(item, index) in details.tag_dict" :key="index" class="my-tag">{{item.tag_name}}</span>
                        </div>
                        <div class="tag-content" v-else>
                            暂无标签
                        </div>
                    </div>
                    <div style="margin-top:20px">
                        所属行业 ： 
                        <span v-if="details.industry_dict.length > 0" v-for="d_i in details.industry_dict">{{d_i.industry_name}}、</span>
                        <span v-else >暂无</span>
                    </div>
                    <div class="marTop">
                        法人姓名：{{submit_customer.legal_name}}
                    </div>
                    <div class="marTop">
                        法人手机号：{{submit_customer.legal_phone}}
                    </div>
                    <div class="marTop">
                        法人身份证号码{{submit_customer.card_id}}
                    </div>
                    <div class="marTop">
                        应急手机号{{submit_customer.legal_wechat_number}}
                    </div>
                    <div class="marTop">
                        对公账户：{{submit_customer.bank_number}}
                    </div>
                    <div class="marTop">
                        对公开户行名称：{{submit_customer.bank_name}}
                    </div>
                    <div class="marTop">
                        对公开户行地址：{{submit_customer.legal_bank_address}}
                    </div>
                    <div class="marTop">
                        法人结算银行卡号：{{submit_customer.legal_bank_number}}
                    </div>
                    <div class="marTop">
                        法人结算银行卡开户行名称：{{submit_customer.legal_bank_name}}
                    </div>
                    <div class="marTop">
                        法人结算银行卡开户行地址：{{submit_customer.legal_bank_address}}
                    </div>
                    <div class="marTop">
                        <a v-if="submit_customer.business_imgs" target="_blank" :href="submit_customer.business_imgs">营业执照：查看</a>
                        <span v-else style="color:#ff0000">营业执照：暂无</span>
                    </div>
                    <div class="marTop">
                        <a v-if="submit_customer.card_front_imgs" target="_blank" :href="submit_customer.card_front_imgs">身份证正面：查看</a>
                        <span v-else style="color:#ff0000">身份证正面：暂无</span>
                    </div>
                    <div class="marTop">
                        <a v-if="submit_customer.card_back_imgs" target="_blank" :href="submit_customer.card_back_imgs">身份证反面：查看</a>
                        <span v-else style="color:#ff0000">身份证反面：暂无</span>
                    </div>
                    <div class="marTop">
                        <a v-if="submit_customer.door_pic_url" target="_blank" :href="submit_customer.door_pic_url">门头照：查看</a>
                        <span v-else style="color:#ff0000">门头照：暂无</span>
                    </div>
                    <div class="marTop">
                        <a v-if="submit_customer.indoor_pic_url" target="_blank" :href="submit_customer.indoor_pic_url">室内场景照片1：查看</a>
                        <span v-else style="color:#ff0000">室内场景照片1：暂无</span>
                    </div>
                    <div class="marTop">
                        <a v-if="submit_customer.hand_card_pic_url" target="_blank" :href="submit_customer.hand_card_pic_url">室内场景照片2：查看</a>
                        <span v-else style="color:#ff0000">室内场景照片2：暂无</span>
                    </div>
                    <div class="marTop">
                        <a v-if="submit_customer.bank_pic_url" target="_blank" :href="submit_customer.bank_pic_url">室内场景照片3：查看</a>
                        <span v-else style="color:#ff0000">室内场景照片3：暂无</span>
                    </div>
                </div>
            </div>
            <div style="flex:2" class="my-mod-left">
                <div class="my-white-mod" style="display: flex;">
                    <div class="follow-status" style="flex:1">
                        <div class="title-font">当前状态</div>
                        <div class="follow-status-content" v-if="details.follow_dict != '{}' && details.follow_dict.follow_type != undefined">
                            <div>{{details.follow_dict.follow_type == 1 ? '首次跟进' : '第'+details.follow_dict.follow_type+'次跟进' }}</div>
                            <div>{{details.follow_dict.follow_time}} <span style="margin-left:20px">{{details.follow_dict.responsible_name}}</span></div>
                        </div>
                        <div class="follow-status-content" v-else>
                            暂无跟进
                        </div>
                    </div>
                    <div style="flex:2">
                        <div class="title-class">
                            <div class="title-font">订单交付内容({{ order_id }})</div>
                        </div>
                        <table class="first-info">
                            <tr>
                                <td>平台名称：{{services_info.platform_name}}</td>
                                <td colspan="2">登录地址：{{services_info.login_url}}</td>
                                
                            </tr>
                            <tr>
                                <td>账户：{{services_info.account}}</td>
                                <td>密码：{{services_info.pwd}}</td>
                                <td>所属系统：{{services_info.order_product}}</td>
                            </tr>
                            <tr>
                                <td colspan="3">服务要求：{{services_info.service_requirements}}</td>
                            </tr>
                        </table>
                    </div>
                    
                </div>
                <div class="my-white-mod" >
                    <div class="title-class">
                        <div class="title-font">跟进记录</div>
                    </div>
                    <PageTable  :loading="follow_table.loading" :size="follow_table.limit" :columns="follow_table.columns" :data="follow_table.data" :current="follow_table.current" :total="follow_table.total"  @switchPage="change_record"  >
                    </PageTable>
                </div>
                <div class="my-white-mod" >
                    <div class="title-class">
                        <div class="title-font">成交记录</div>
                        <Button  type="primary" @click="add_order" >新增</Button >
                    </div>
                    <PageTable  :loading="success_table.loading" :size="success_table.limit" :columns="success_table.columns" :data="success_table.data" :current="success_table.current" :total="success_table.total"  @switchPage="change_success"  >
                    </PageTable>
                </div>
            </div>
        </div>
        <Modal
                :mask-closable="false"
                v-model="show_qrcode"
                title="二维码"
                width="600"
        >
            <div style="display: flex;align-items: center;">
                <CheckboxGroup v-model="qrcode_mode">
                        <Checkbox :label="1" >基本资料</Checkbox>
                        <!-- <Checkbox :label="3" >个体户资料</Checkbox>
                        <Checkbox :label="5" >个体户支付</Checkbox>
                        <Checkbox :label="2" >对公资料</Checkbox>
                        <Checkbox :label="6" >对公支付</Checkbox> -->
                        <Checkbox :label="4" >经营场景资料</Checkbox>
                        <Checkbox :label="7" >企业类型选择</Checkbox>
                    </CheckboxGroup>
                    <Button type="primary" style="margin-left:20px" @click="setCustomerQrcode">保存</Button>
            </div>
            <span style="color:#ff0000">每次点击保存按钮，用户可重新填写相关信息</span>
            <div style="text-align: center;">
                <vueQr v-if="qrcode_url" :text="qrcode_url" ></vueQr>
            </div>
           
                
                <div slot="footer"></div>
        </Modal>
        <Modal
                :mask-closable="false"
                v-model="show_infos"
                title="客户资料"
                width="800"
        >
            <div>
                <div class="cur_box_cla">
                    <div class="cur_itm_cla">
                        <div class="modal-title"><span style="color:#ff0000">*</span>姓名</div>
                        <Input  placeholder="请填写姓名" :disabled="submitInfo.name ? true : false"  v-model="submitInfo.name"  />
                    </div>
                    <div class="cur_itm_cla" >
                        <div class="modal-title">备注</div>
                        <Input  placeholder="请填写备注"  v-model="submitInfo.remark"  />
                    </div>
                </div>
                <div class="cur_box_cla">
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">性别</div>
                        <Select  placeholder="请选择性别" v-model="submitInfo.gender" >
                            <Option v-for="item in genderArr" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">生日</div>
                        <DatePicker type="date" v-model="submitInfo.birthday" placeholder="选择日期" style="width: 200px" @on-change="change_date"></DatePicker>
                    </div>
                </div>

                <div class="cur_box_cla">
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">手机号</div>
                        <Input  placeholder="请填写手机号"  v-model="submitInfo.phone" />
                    </div>
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two"><span style="color:#ff0000">*</span>微信昵称</div>
                        <Input  placeholder="请填写微信昵称" v-model="submitInfo.wechat_number" />
                    </div>
                </div>

                <div class="cur_box_cla">
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">旺旺号</div>
                        <Input  placeholder="请填写旺旺号" v-model="submitInfo.wangwang_number"  />
                    </div>
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">邮箱</div>
                        <Input  placeholder="请填写邮箱"  v-model="submitInfo.email" />
                    </div>
                </div>
                <div class="cur_box_cla">
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">营业执照名称</div>
                        <Input placeholder="请填写营业执照名称"  v-model="submitInfo.company_name"  />
                    </div>
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">选择城市</div>
                        <CitySelect @select_city="select_city" :default_citys="submitInfo.city_number"></CitySelect>
                    </div>
                </div>

                <div class="cur_box_cla">
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">详细地址</div>
                        <div :class="submitInfo.detailed_address ? 'dis-f' : ''">
                            <Input placeholder="请填写详细地址" v-model="submitInfo.detailed_address" class="mr-12"/>
                            <Button v-if="submitInfo.detailed_address" type="primary" @click="show_latitude = true">选择经纬度</Button>
                        </div>
                    </div>
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">是否为大客户</div>
                        <RadioGroup v-model="submitInfo.is_big">
                            <Radio label="1">是</Radio>
                            <Radio label="0" >否</Radio>
                        </RadioGroup >
                    </div>
                </div>
                <div class="cur_box_cla">
                    <div class="cur_itm_cla">
                        <div class="modal-title modal-title-two">经纬度</div>
                        <Input placeholder="经纬度" v-model="submitInfo.latlng" disabled/>
                    </div>
                    <div class="cur_itm_cla">
                        
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button  type="primary"  @click="save_custmer">确定</Button >
            </div>
        </Modal>

        <Modal
                :mask-closable="false"
                v-model="show_infos_portrait"
                title="用户详情"
                width="800"
        >
            <div style="display: flex;width:100%">
                <div style="flex:1;">
                    <div class="modal-title modal-title-two">法人姓名</div>
                    <Input style="width:80%" type="text" placeholder="请填写法人姓名" v-model="submit_customer.legal_name" />

                    <div class="modal-title modal-title-two">法人手机号</div>
                    <Input style="width:80%" type="text" placeholder="请填写法人手机号" v-model="submit_customer.legal_phone" />
                    <div class="modal-title modal-title-two">法人身份证号码</div>
                    <Input style="width:80%" type="text" placeholder="请填写法人身份证号码" v-model="submit_customer.card_id" />
                    <div class="modal-title modal-title-two">应急手机号</div>
                    <Input style="width:80%" type="text" placeholder="请填写应急手机号" v-model="submit_customer.legal_wechat_number" />
                    <div class="modal-title modal-title-two">所属行业</div>
                    <Select placeholder="请选择行业" filterable multiple v-model="submit_customer.industry" style="width:80%">
                        <Option v-for="item in industry_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <div class="modal-title modal-title-two">营业执照</div>
                    <Upload :action="config.allImgUploadUrl" :data="upload_data" name="pic" :show-upload-list="false" :on-success="handleSuccess_business" :before-upload="before_upload_business" >
                        <Button icon="ios-cloud-upload-outline">请选择营业执照</Button>
                    </Upload>
                    <a target="_blank" v-if="submit_customer.business_imgs" :href="submit_customer.business_imgs">
                        <img  style="width:200px;height:100px;margin-top:5px" :src="submit_customer.business_imgs" />
                    </a>
                    
                </div>
                <div  style="flex:1">
                    <div class="modal-title modal-title-two">身份证正面</div>
                    <Upload :action="config.allImgUploadUrl" name="pic" :data="upload_data" :show-upload-list="false" :on-success="handleSuccess_card_front" :before-upload="before_upload_card_front" >
                        <Button icon="ios-cloud-upload-outline">请选择身份证正面照</Button>
                    </Upload>
                    <a target="_blank" v-if="submit_customer.card_front_imgs" :href="submit_customer.card_front_imgs">
                        <img style="width:200px;height:100px;margin-top:5px" :src="submit_customer.card_front_imgs" />
                    </a>
                    <div class="modal-title modal-title-two">身份证反面</div>
                    <Upload :action="config.allImgUploadUrl" :data="upload_data" name="pic" :show-upload-list="false" :on-success="handleSuccess_card_back" :before-upload="before_upload_card_back" >
                        <Button icon="ios-cloud-upload-outline">请选择身份证反面照</Button>
                    </Upload>
                    <a target="_blank" v-if="submit_customer.card_back_imgs" :href="submit_customer.card_back_imgs">
                        <img  style="width:200px;height:100px;margin-top:5px" :src="submit_customer.card_back_imgs" />
                    </a>
                </div>
            </div>
            <Divider style="margin-top:30px">银行资料</Divider>
            <div style="display: flex;">
                <div style="flex:1">

                    <div class="modal-title modal-title-two">对公账号</div>
                    <Input type="text" style="width:80%" placeholder="请填写对公账号" v-model="submit_customer.bank_number" />

                    <div class="modal-title modal-title-two">对公开户行名称</div>
                    <Input type="text" style="width:80%" placeholder="请填写对公开户行名称" v-model="submit_customer.bank_name" />
                    <div class="modal-title modal-title-two">对公开户行地址</div>
                    <Input type="text" style="width:80%" placeholder="请填写对公开户行地址" v-model="submit_customer.legal_bank_address" />
                </div>
                <div style="flex:1">
                    <div class="modal-title modal-title-two">法人结算银行卡号</div>
                    <Input type="text" style="width:80%" placeholder="请填写法人结算银行卡号" v-model="submit_customer.legal_bank_number" />

                    <div class="modal-title modal-title-two">法人结算银行卡开户行名称</div>
                    <Input type="text" style="width:80%" placeholder="请填写法人结算银行卡开户行" v-model="submit_customer.legal_bank_name" />

                    <div class="modal-title modal-title-two">法人结算银行卡开户行地址</div>
                    <Input type="text" style="width:80%" placeholder="请填写法人结算银行卡开户行地址" v-model="submit_customer.legal_bank_address" />

                </div>
            </div>
            <Divider  style="margin-top:30px">经营场景资料</Divider>
            <div style="display: flex;">
                <div style="flex:1">
                    <div class="modal-title modal-title-two">门头照</div>
                    <Upload :action="config.allImgUploadUrl" :data="upload_data" name="pic" :show-upload-list="false" :on-success="handleSuccess_door" :before-upload="before_upload_door" >
                        <Button icon="ios-cloud-upload-outline">请选择门头照</Button>
                    </Upload>
                    <a target="_blank" v-if="submit_customer.door_pic_url" :href="submit_customer.door_pic_url">
                        <img  style="width:200px;height:100px;margin-top:5px" :src="submit_customer.door_pic_url" />
                    </a>
                    <div class="modal-title modal-title-two">室内场景照片1</div>
                    <Upload :action="config.allImgUploadUrl" :data="upload_data" name="pic" :show-upload-list="false" :on-success="handleSuccess_indoor" :before-upload="before_upload_indoor" >
                        <Button icon="ios-cloud-upload-outline">请选择室内场景照片</Button>
                    </Upload>
                    <a target="_blank" v-if="submit_customer.indoor_pic_url" :href="submit_customer.indoor_pic_url">
                        <img  style="width:200px;height:100px;margin-top:5px" :src="submit_customer.indoor_pic_url" />
                    </a>
                </div>
                <div style="flex:1">
                    <div class="modal-title modal-title-two">室内场景照片2</div>
                    <Upload :action="config.allImgUploadUrl" :data="upload_data" name="pic" :show-upload-list="false" :on-success="handleSuccess_hand_card" :before-upload="before_upload_hand_card" >
                        <Button icon="ios-cloud-upload-outline">请选择室内场景照片</Button>
                    </Upload>
                    <a target="_blank" v-if="submit_customer.hand_card_pic_url" :href="submit_customer.hand_card_pic_url">
                        <img  style="width:200px;height:100px;margin-top:5px" :src="submit_customer.hand_card_pic_url" />
                    </a>
                    <div class="modal-title modal-title-two">室内场景照片3</div>
                    <Upload :action="config.allImgUploadUrl" :data="upload_data" name="pic" :show-upload-list="false" :on-success="handleSuccess_bank" :before-upload="before_upload_bank" >
                        <Button icon="ios-cloud-upload-outline">请选择室内场景照片</Button>
                    </Upload>
                    <a target="_blank" v-if="submit_customer.bank_pic_url" :href="submit_customer.bank_pic_url">
                        <img  style="width:200px;height:100px;margin-top:5px" :src="submit_customer.bank_pic_url" />
                    </a>
                </div>
            </div>
            
            <div slot="footer">
                <Button  type="primary"  @click="set_customer_portrait" >确定</Button >
            </div>
        </Modal>
        <DealShow ref="deal_child" :show_success.sync="show_success"  :department_member_list="department_member_list"  :successSubmit="successSubmit" @submitSuccess="deal_success_order"></DealShow>
        
        <Modal
                v-model="show_latitude"
                title="选择经纬度"
                :mask-closable="false"
                width="700"
                @on-visible-change="handleModalVisibleChange"
        >
            <div>
                <div>请在地图上选择客户所在位置</div>
                <div v-if="isModalMounted">
                    <!-- <tencent-map :address="submitInfo.city_name + submitInfo.detailed_address" :zoom="13" @child-to-parent="handleChildData"/> -->
                    <tencent-map :address="submitInfo.detailed_address" :zoom="13" @child-to-parent="handleChildData"/>
                    <!-- <baiduMap :address="submitInfo.detailed_address" :zoom="13" @child-to-parent="handleChildData"/> -->
                </div>
            </div>
            <div slot="footer">
                <Button  type="primary"  @click="submitLatitude">确定</Button>
            </div>
        </Modal>
        <!-- <Modal
            v-model="show_success"
            title="成交"
            :mask-closable="false"
            width="650"
        >
            <DealShow ref="deal_child" :department_member_list="department_member_list"  :successSubmit="successSubmit"></DealShow>
            <div slot="footer">
                <Button  type="primary"  @click="deal_success_order" >确定</Button >
            </div>
        </Modal> -->
    </div>

</template>
<script>
    import  { follow_record_list, save_customer_info, query_customer_qrcode,set_customer_qrcode, customer_industry_list, set_customer_portrait, customer_department_member} from "@/api/customer"
    import {order_detail, success_order, add_order, order_success} from "@/api/order"
    import {Header, PageTable, CitySelect, DealShow} from "@/components/mainLayout"
    import {getCurrentDate} from "@/utils/helper";
    import config from '@/config';
    import moment from "moment"
    import vueQr from 'vue-qr'
    import TencentMap from "@/components/TencentMap/TencentMap.vue";
    import baiduMap from "@/components/baiduMap/baiduMap.vue";
    export default {
        components:{
        Header,
        PageTable,
        CitySelect,
        vueQr,
        DealShow,
        TencentMap,
        baiduMap,
    },
    data(){
        return{
            qrcode_url:"",
            qrcode_mode:[1],
            show_qrcode:false,
            card_front_img_list:[],
            show_success:false,
            loading_msg:false,
            industry_list:[],
            submitInfo:{},
            submit_customer:{},
            current_date:getCurrentDate(),
            upload_data:{
                remove_id:""
            },
            details:{
                custom_dict:{},
                industry_dict:{},
                service_info:{},
                follow_dict:{}
            },
            services_info:{},
            successSubmit:{
                customer_source_id:"",
                duesoon_type:'1',
                money:"",
                transaction_type_id:"",
                aftersale_id:"",
                service_requirements:"",
                servicecharge:"",
                qq_group:"",
                retainage:"",
                name:"",
                phone:"",
                remark:"",
                wechat_number:"",
                wangwang_number:"",
                city_number:[],
                city_name:"",
                detailed_address:"",
                id:"",
                is_two_sale:"",
                latlng: "",
                is_big: '0',
            },
            order_id:"",
            show_infos_portrait:false,
            show_infos:false,
            genderArr:[
                {id:1, name:'男'},
                {id:2, name:'女'}
            ],
            follow_table: {
                loading:false,
                current: 1,
                total: 0,
                limit: 30,
                columns: [
                    {
                        type:'index',
                        width:'80',
                        align:'center'
                    },{
                        title: '跟进时间',
                        align:'center',
                        width:'200',
                        key: 'follow_time'
                    },{
                        title: '状态',
                        align:'center',
                        key: 'id',
                        render: (h, params) => {
                            console.log(params.row)
                            let status_name = params.row.follow_type == 1 ? "首次跟进" : `第`+params.row.follow_type+`次跟进`;
                            return h('div', [
                                h('span', {}, status_name)
                            ]);

                        }
                    },{
                        title: '图片',
                        align:'center',
                        key: 'ctime',
                        render: (h, params) => {
                            let img_arr = [];
                            for (let i in params.row.follow_img) {
                                img_arr.push(params.row.follow_img[i].url)
                            }
                            if(img_arr.length > 0){
                                return h('div', img_arr.map(img=>{ //循环显示
                                        return h('img',  {
                                            attrs: {
                                                src: img,
                                                style: 'width: 30px;height: 30px;cursor:pointer'
                                            },
                                            on:{
                                                click:()=>{
                                                    
                                                    this.$Modal.info({
                                                        title: '预览',
                                                        width:'800px',
                                                        content: '<a target="_blank" href="'+img+'" ><img style="width:100%;hieght:1005" src="'+img+'" /></a>'

                                                    })
                                                }
                                            }
                                        },);
                                    })
                                )
                            }else{
                                return h("span", '');
                            }

                        }
                    },{
                        title: '备注',
                        align:'center',
                        key: 'note',
                        render: (h, params) => {
                            return h('Input',{
                                props: {
                                    value:params.row.note,
                                    type:'textarea'
                                }
                            })
                        }
                    },{
                        title: '负责人员',
                        align:'center',
                        key: 'responsible_name'
                    }],
                data:[]
            },
            success_table: {
                loading:false,
                current: 1,
                total: 0,
                limit: 30,
                columns: [{
                        title: '订单ID',
                        width:'100',
                        align:'center',
                        key: 'id',
                        render: (h, params) => {
                            let retainage_text = params.row.most_retainage_id ? "<span style='color:red'>尾款主单"+params.row.most_retainage_id+"</span>" :""
                            let text = params.row.is_examine == 1?"<span style='color:red'>已审核</span>" :"";
                            let delivery_text = params.row.delivery_status == 0?"<span style='color:red'>未交付</span>" :params.row.delivery_status == 9?"<span style='color:#000'>停止对接</span>" :"";
                            
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div>`+params.row.id+`</div>`+`<div>`+(params.row.order_number ? params.row.order_number : "")+`</div><div >`+ delivery_text  +`</div><div >`+ text  +`</div><div >`+ retainage_text  +`</div>`
                                }
                            })
                        }
                    },{
                        title: '平台名',
                        width:'100',
                        align:'center',
                        key: 'platform_name'
                    },{
                        title: '金额',
                        align:'center',
                        render: (h, params) => {
                            const pay_money = params.row.pay_money
                            const retainage = (params.row.retainage_status === 0 && params.row.retainage > 0) ? params.row.retainage : 0
                            const servicecharge = params.row.servicecharge
                            return h('div', [
                                h('div', `订单金额: ${pay_money}`),
                                h('div', `尾款: ${retainage}`),
                                h('Tooltip', {
                                    props: {
                                        placement: 'top',
                                        transfer: true,  // 防止父容器溢出隐藏
                                        content: '作为下次收款的依据'
                                    },
                                    nativeOn: {
                                        mouseover: e => e.stopPropagation() // 防止事件冒泡
                                    }
                                }, [
                                    h('div', {
                                        style: {
                                            cursor: 'pointer',
                                            display: 'inline-block', // 需要设置为行内元素
                                        }
                                    }, `服务费: ${servicecharge}`)
                                ])
                            ])
                        }
                    },{
                        title: '成交日期',
                        width:'110',
                        align:'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, params.row.pay_time.replace("T", " "))
                            ]);
                        }
                    },{
                        title: '过期时间',
                        width:'110',
                        align:'center',
                        key: 'expiration_date',
                        render: (h, params) => {
                            return h('span',{
                            }, params.row.duesoon_type  == 1 ? params.row.expiration_date : '永久有效')
                        }
                    },{
                        title: '服务要求',
                        width:'100',
                        align:'center',
                        key: 'service_requirements',
                        render: (h, params) => {
                            return h('Input',{
                                props: {
                                    value:params.row.service_requirements,
                                    type:'textarea'
                                }
                            })
                        }
                    },{
                        title: '负责人员',
                        width:'100',
                        align:'center',
                        key: 'department_member_name'
                    }],
                data:[]
            },
            location_type:'3',
            department_member_list:[],
            commit:0,
            show_latitude: false,
            isModalMounted: false,
            latlngData: "",
        }
    },
    mounted(){
        let query = this.$route.query;
        this.order_id = query.order_id;
        this.customer_id = query.customer_id;
        this.location_type = query.type;
        this.get_detail()
        this.record_list();
        this.get_industry();
        this.success_list();
        this.get_customer_department_member();
    },
    methods:{
        handleChildData(data) {
            this.latlngData = data.lat + ',' + data.lng;
        },
        handleModalVisibleChange(visible) {
            if (visible) {
                this.$nextTick(() => {
                    this.isModalMounted = true;
                });
            } else {
                this.isModalMounted = false;
            }
        },
        submitLatitude() {
            this.submitInfo.latlng = this.latlngData;
            this.show_latitude = false;
        },
        get_customer_department_member(){
            customer_department_member().then(res=>{
                this.department_member_list = res.data
            })
        },
        add_order(){
            this.successSubmit.id = this.order_id;
            console.log(this.successSubmit)
            this.show_success = true
        },
        deal_success_order(){
            add_order({customer_id:this.customer_id}).then(res=>{
                if(res.code == 200) {
                    this.successSubmit.id = res.data
                    order_success(this.successSubmit).then(r=>{
                        this.$Message.destroy()
                        if (r.code == 200) {
                            this.successSubmit.duesoon_type = '1'
                            this.successSubmit.money = ''
                            this.successSubmit.transaction_type_id = ''
                            this.successSubmit.aftersale_id = ''
                            this.successSubmit.service_requirements = ''
                            this.successSubmit.servicecharge = ''
                            this.successSubmit.qq_group = ''
                            this.successSubmit.retainage = ''
                            this.successSubmit.wechat_number = ''
                            this.successSubmit.customer_source_id = '';
                            this.successSubmit.is_two_sale = '';
                            this.successSubmit.latlng = '';
                            this.successSubmit.is_big = '0';
                            this.show_success = false;
                            this.$Message.success(r.msg);
                            this.success_table.current = 1
                            this.success_list();
                        } else {
                            this.$Message.error(r.msg);
                        }
                        this.refs.deal_child.is_submit = 0;
                    })
                } else {
                    this.refs.deal_child.is_submit = 0;
                    this.show_success = false
                    this.$Message.destroy()
                    this.$Message.error(res.msg);
                }
            })
        },
        get_detail(){
            order_detail({order_id:this.order_id}).then(res=>{
                this.loading_msg = true
                if(res.code == 200) {
                    this.details = res.data;
                    this.submitInfo = {
                        order_id:this.order_id,
                        id:this.details.custom_dict.id,
                        gender:this.details.custom_dict.gender,
                        name : this.details.custom_dict.name,
                        birthday: this.details.custom_dict.birthday,
                        phone: this.details.custom_dict.phone,
                        wechat_number: this.details.custom_dict.wechatNumber,
                        wangwang_number: this.details.custom_dict.wangwangNumber,
                        email: this.details.custom_dict.email,
                        company_name: this.details.custom_dict.companyName,
                        detailed_address: this.details.custom_dict.detailedAddress,
                        remark:this.details.custom_dict.remark,
                        city_name:this.details.custom_dict.city_name,
                        city_number:[this.details.custom_dict.prov, this.details.custom_dict.city, this.details.custom_dict.area ],
                        is_big: this.details.custom_dict.is_big ? this.details.custom_dict.is_big + '' : '0',
                        latlng: this.details.custom_dict.latlng,
                    }; 
                    this.services_info = this.details.service_info
                    this.services_info.order_product = this.details.order_product
                    this.submit_customer = {
                        id:this.details.custom_dict.id,
                        legal_bank_address:this.details.custom_dict.legal_bank_address,
                        legal_wechat_number:this.details.custom_dict.legal_wechat_number,
                        card_id:this.details.custom_dict.card_id,
                        legal_bank_name:this.details.custom_dict.legal_bank_name,
                        legal_bank_number:this.details.custom_dict.legal_bank_number,
                        legal_name:this.details.custom_dict.legal_name,
                        legal_phone:this.details.custom_dict.legal_phone,
                        bank_name:this.details.custom_dict.bank_name,
                        bank_number:this.details.custom_dict.bank_number,
                        industry:this.details.custom_dict.industry ? this.details.custom_dict.industry.split(",") :[],

                        bank_pic:this.details.custom_dict.bank_pic,
                        hand_card_pic:this.details.custom_dict.hand_card_pic,
                        indoor_pic:this.details.custom_dict.indoor_pic,
                        door_pic:this.details.custom_dict.door_pic,
                        business_id:this.details.custom_dict.business_id,
                        card_id_front:this.details.custom_dict.card_id_front,
                        card_id_back:this.details.custom_dict.card_id_back,

                        bank_pic_url:this.details.custom_dict.bank_pic_url,
                        hand_card_pic_url:this.details.custom_dict.hand_card_pic_url,
                        indoor_pic_url:this.details.custom_dict.indoor_pic_url,
                        door_pic_url:this.details.custom_dict.door_pic_url,
                        business_imgs:this.details.custom_dict.business_imgs,
                        card_front_imgs:this.details.custom_dict.card_front_imgs,
                        card_back_imgs:this.details.custom_dict.card_back_imgs
                    }
                    this.submit_customer.industry = this.submit_customer.industry.map(function (data) {
                        return +data;
                    });
                    this.successSubmit.is_two_sale = "0"
                    this.successSubmit.pay_time = this.current_date
                    this.successSubmit.name = this.submitInfo.name
                    this.successSubmit.remark = this.submitInfo.remark
                    this.successSubmit.city_name = this.submitInfo.city_name
                    this.successSubmit.phone = this.submitInfo.phone
                    this.successSubmit.wechat_number = this.submitInfo.wechat_number
                    this.successSubmit.wangwang_number = this.submitInfo.wangwang_number
                    this.successSubmit.city_number = this.submitInfo.city_number
                    this.successSubmit.city_name = this.submitInfo.city_name
                    this.successSubmit.detailed_address = this.submitInfo.detailed_address
                    this.successSubmit.latlng = this.submitInfo.latlng
                    this.successSubmit.is_big = this.submitInfo.is_big
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },

        select_city(e){
            this.submitInfo.city_name = e.city_name
            this.submitInfo.city_number = e.city_number
        },
        // 查询跟进记录
        record_list(){
            this.follow_table.loading = true;
            follow_record_list({order_id:this.order_id, limit:this.follow_table.limit, page:this.follow_table.current}).then(res=>{
                this.follow_table.loading = false;
                if (res.code == 200) {
                    this.follow_table.data = res.data;
                    this.follow_table.total = res.total;
                } else {
                    this.follow_table.data = [];
                    this.follow_table.total = 0;
                    // this.$Message.error(res.msg);
                }
            })
        },
        // 跟进记录换页
        change_record(e){
            this.follow_table.current = e;
            this.record_list();
        },
        success_list(){
            this.success_table.loading = true;
            success_order({order_id:this.order_id, customer_id:this.customer_id, limit:this.success_table.limit, page:this.success_table.current}).then(res=>{
                this.success_table.loading = false;
                if (res.code == 200) {
                    this.success_table.data = res.data;
                    this.success_table.total = res.total;
                } else {
                    this.success_table.data = [];
                    this.success_table.total = 0;
                    // this.$Message.error(res.msg);
                }
            })
        },
        // 成交记录换页
        change_success(e){
            this.success_table.current = e;
            this.success_list();
        },
        change_date(e){
            this.submitInfo.birthday = e;
        },
        save_custmer(){
            if (this.submitInfo.name == "" || this.submitInfo.name == null) {
                this.$Message.error("用户姓名不能为空");return;
            }
            if (this.submitInfo.wechat_number == "" || this.submitInfo.wechat_number == null) {
                this.$Message.error("用户微信昵称不能为空");return;
            }
            if (this.submitInfo.birthday != "" && this.submitInfo.birthday != null) {
                this.submitInfo.birthday = moment(this.submitInfo.birthday).format('YYYY-MM-DD')
            }
            if(this.submitInfo.is_big == 1 && !this.submitInfo.company_name) {
                this.$Message.error("大客户请填写营业执照名称");return;
            }
            save_customer_info(this.submitInfo).then(res=>{
                if (res.code == 200) {
                    this.show_infos = false
                    this.get_detail()
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },

        get_industry(){
            customer_industry_list().then(res=>{
                this.industry_list = res.data
            })
        },
        set_customer_portrait(){
            this.submit_customer.industry = this.submit_customer.industry ? this.submit_customer.industry.join(",") : ""
            
            set_customer_portrait(this.submit_customer).then(res=>{
                if (res.code == 200) {
                    this.show_infos_portrait = false;
                    this.get_detail()
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        handleSuccess_card_front(res, file){
            if (res.code == 200) {
                this.submit_customer.card_front_imgs = res.data.url
                this.submit_customer.card_id_front = res.data.id
                this.$forceUpdate()
            }
        },
        handleSuccess_card_back(res) {
            if (res.code == 200) {
                this.submit_customer.card_back_imgs = res.data.url
                this.submit_customer.card_id_back = res.data.id
                this.$forceUpdate()
            }
        },
        before_upload_card_front(){
            this.upload_data.remove_id = this.submit_customer.card_id_front ? this.submit_customer.card_id_front : ""
        },
        before_upload_card_back(){
            this.upload_data.remove_id = this.submit_customer.card_id_back ?  this.submit_customer.card_id_back : ""
        },
        handleSuccess_business(res){
            if (res.code == 200) {
                this.submit_customer.business_imgs = res.data.url
                this.submit_customer.business_id = res.data.id
                this.$forceUpdate()
            }
        },
        before_upload_business(){
            this.upload_data.remove_id = this.submit_customer.business_id ?  this.submit_customer.business_id : ""
        },
        handleSuccess_door(res){
            if (res.code == 200) {
                this.submit_customer.door_pic_url = res.data.url
                this.submit_customer.door_pic = res.data.id
                this.$forceUpdate()
            }
        },
        before_upload_door(){
            this.upload_data.remove_id = this.submit_customer.door_pic ?  this.submit_customer.door_pic : ""
        },
        handleSuccess_indoor(res){
            if (res.code == 200) {
                this.submit_customer.indoor_pic_url = res.data.url
                this.submit_customer.indoor_pic = res.data.id
                this.$forceUpdate()
            }
        },
        before_upload_indoor(){
            this.upload_data.remove_id = this.submit_customer.indoor_pic ?  this.submit_customer.indoor_pic : ""
        },
        handleSuccess_hand_card(res){
            if (res.code == 200) {
                this.submit_customer.hand_card_pic_url = res.data.url
                this.submit_customer.hand_card_pic = res.data.id
                this.$forceUpdate()
            }
        },
        before_upload_hand_card(){
            this.upload_data.remove_id = this.submit_customer.hand_card_pic ?  this.submit_customer.hand_card_pic : ""
        },
        handleSuccess_bank(res){
            if (res.code == 200) {
                this.submit_customer.bank_pic_url = res.data.url
                this.submit_customer.bank_pic = res.data.id
                this.$forceUpdate()
            }
        },
        before_upload_bank(){
            this.upload_data.remove_id = this.submit_customer.bank_pic ?  this.submit_customer.bank_pic : ""
        },
        showQrcodeModal(){
            query_customer_qrcode({cid:this.submit_customer.id}).then(res=>{
                this.show_qrcode = true
                this.qrcode_url =  res.data.url
                if (res.data.mode != "") {
                    this.qrcode_mode = res.data.mode.split(",")
                    this.qrcode_mode = this.qrcode_mode.map(item=>{
                        return +item
                    })
                }
                
            })
        },
        setCustomerQrcode(){
            console.log(this.qrcode_mode)
            let mode = this.qrcode_mode? this.qrcode_mode.join(",") : ""
            set_customer_qrcode({cid:this.submit_customer.id, mode:mode}).then(res=>{
                    this.$Message.success(res.msg);
                this.qrcode_url =  res.data
            })
        }
    }
}
</script>
<style scoped>
    >>>.my-mod-right{
        margin-right:10px;
        width:500px;
        /* width: 30%; */
    }
    
    >>>.my-mod-left{
        /* width: 60%; */
        margin-left:10px
    }
    >>>.my-white-mod{
        height:unset;
    }
    >>>.edit:before{
        content: "\e607";
        font-family: "iconfont" !important;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0A1629;
        font-size: 20px;
        background: #F4F9FD;
        border-radius: 12px;
        cursor: pointer;
    }
    >>>.title-class{
        display: flex;
        justify-content: space-between;
    }
    >>>.title-font{
        font-weight: bold;
        color:#0A1629;
    }
    >>>.head-content{
        display:flex;align-items:center;font-size:16px
    }
    >>>.head-content-img{
        width:80px;height:80px;border-radius: 50%;border: 1px solid #fbf9f9;
    }
    >>>.head-content-name{
        flex:1;margin-left:10px
    }
    >>>.head-content-name-class{
        display: flex; align-items:center;
    }
    >>>.head-content-name-img{
        margin-left:5px;width:20px;height:20px;
    }
    >>>.my-white-mod .ivu-row{
        padding:10px
    }
    >>>.my-tag{
        border:1px solid #7D8592;
        padding:5px 10px;
        border-radius: 10px;
        margin:5px;
    }
    >>>.tag-content{
        margin-top:10px;
        display: flex;
        flex-wrap: wrap;
    }
    >>>.follow-status{
        display:flex;justify-items: flex-start
    }
    >>>.follow-status-content{
        margin-left:20px;font-size: 18px
    }


    >>>.ivu-row .ivu-col{
        color:#445E87!important;
    }
    >>>.ivu-modal .ivu-picker-confirm .ivu-btn-text{
        display: block;
    }
    .marTop{
        margin-top:10px
    }
    .marTop a{
        color:#445E87FF!important;
        cursor: pointer;
    }
    .first-info{
        width:100%
    }
    .dis-f {
        display: flex;
    }
    .mr-12 {
        margin-right: 12px;
    }
    >>>.is-big {
        margin-left:5px;
        width: 64px;
        height: 21px;
    }
</style>
